import List from './CourseList'
import Create from './CreateCourse'
import Details from './Details'
const exportObj = {
    Create,
    Details,
    List,
}

export default exportObj